// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__8KA5w","assignButton":"CreateEditEquipmentSchedule_assignButton__1OtUM"};